import React from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {changeResource} from "../../../../../../../../actions/sqftResourceFunctions";
import workspaceControllers from "../../../../../canvas/store/workspaceControllers";
import PropTypes from "prop-types";
import {waterfallSegmentInterface} from "../../../../../../interfaces/sqftInterfaces";

const NavWaterfallSegmentSwitcher = (props) => {

  const {waterfallSegmentData,  } = props;

  const handleButtonClick = () => {
    const waterfallSegment = workspaceControllers.waterfall.getSegmentById(waterfallSegmentData.id);
    workspaceControllers.waterfall.segmentController.changeSegmentIsDisabled(waterfallSegmentData.id, !waterfallSegment.isDisabled);
  };

  return (
    <div className="ui-radio-block">
      <span className="ui-radio-label"></span>
      <button className={"ui-radio ui-radio--small" + (!waterfallSegmentData.isDisabled ? " ui-radio--checked" : "")}
              onClick={handleButtonClick}>
        <span className="ui-radio-circle"/>
        <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
        <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
      </button>
    </div>
  )
};

NavWaterfallSegmentSwitcher.propTypes = {
  waterfallSegmentData: PropTypes.shape(waterfallSegmentInterface),
};

const mapStateToProps = (store) => {
  const {showAdvancedQuoting} = store.advancedQuotingState;
  return {
    showAdvancedQuoting,
  };
};

const mapDispatchToProps = {
  changeResource
};

export default connect(mapStateToProps, mapDispatchToProps)(NavWaterfallSegmentSwitcher);
